<script lang="ts">
	import favicon from '$lib/assets/favicon.png';
	import { resolve } from '$app/paths';

	import BusyIndicator from '$lib/components/BusyIndicator.svelte';
	import { MAIN_TABS } from '$lib/constants';
	import { appState } from '$lib/appstate.svelte';
	import logoUrl from '$lib/assets/logo-small.png';

	import '$lib/app.css';

	import { verbTabURL } from '$lib/urlutils.svelte';

	let { children } = $props();

	let link = $derived.by(() => {
		if (appState.verb) {
			return verbTabURL(appState.verb.searchName, appState.verbTab);
		} else {
			return '/';
		}
	});
</script>

<svelte:head>
	<title>French verb conjugations and meanings</title>
	<meta name="description" content="French verb conjugations" />

	<link rel="icon" href={favicon} />
</svelte:head>

<BusyIndicator />

<nav id="main-links" class="flex h-16 w-full items-center bg-teal-700 px-6">
	<img src={logoUrl} class="h-12 w-12" alt="Logo" />
	<a
		href={link}
		class={`tab-link theme-link mr-4 font-semibold
    ${appState.mainTab === MAIN_TABS.HOME ? 'pointer-events-none opacity-60' : ''}`}
	>
		Verb Search
	</a>
	{#if appState.isLoggedIn}
		<a
			href={resolve('/allquiz')}
			class={`tab-link theme-link mr-4 font-semibold
    ${appState.mainTab === MAIN_TABS.QUIZ ? 'pointer-events-none opacity-60' : ''}`}
		>
			Quiz
		</a>
	{/if}
	<a
		href={resolve('/stats')}
		class={`theme-link mr-4 font-semibold
    ${appState.mainTab === MAIN_TABS.STATS ? 'pointer-events-none opacity-60' : ''}`}
	>
		Stats
	</a>
	<a
		href={resolve('/about')}
		class={`theme-link mr-4 font-semibold
    ${appState.mainTab === MAIN_TABS.ABOUT ? 'pointer-events-none opacity-60' : ''}`}
	>
		About
	</a>
	{#if appState.isLoggedIn}
		<a
			href={resolve('/messages')}
			class={`theme-link mr-4 font-semibold
    ${appState.mainTab === MAIN_TABS.MESSAGES ? 'pointer-events-none opacity-60' : ''}`}
		>
			Messages
		</a>
	{/if}
	{#if appState.isLoggedIn}
		<a
			href={resolve('/hints')}
			class={`theme-link mr-4 font-semibold
    ${appState.mainTab === MAIN_TABS.HINTS ? 'pointer-events-none opacity-60' : ''}`}
		>
			Hints
		</a>
	{/if}
</nav>
<main id="main" class="w-full px-3 pt-4" style="background-color: var(--lightgray);">
	{@render children?.()}
</main>
